import { IImportModel } from '../importer/model';

export const staticRatesAvailabilityImportDomainSelector = (state: any): IImportModel =>
  state.staticRatesAvailabilityImport as IImportModel;
